import Contacts from '../components/Contacts'


export default Contacts;